<mat-card id="page-content">
    <!-- <mat-card-title>{{ 'USER_GROUPS' | translate }}</mat-card-title> -->
    <mat-card-content>
        <form [formGroup]="form" class="form-container">
            <mat-grid-list cols="3" rowHeight="80px">
                <!-- <mat-grid-tile colspan="1"></mat-grid-tile> -->
                <mat-grid-tile colspan="1">
                    <mat-form-field appearance="outline">
                        <mat-label>{{ 'USERS' | translate }}</mat-label>
                        <mat-select formControlName="users" size="small">
                            @for (ct of usersList; track ct) {
                                <mat-option [value]="ct">{{ ct }}</mat-option>
                            }
                        </mat-select>
                        @if (f['users'].errors) {
                            <mat-error>
                                @if (f['users'].errors['required']) {
                                    <span>{{
                                            'FIELD_REQUIRED' |
                                                translate
                                        }}</span>
                                }
                            </mat-error>
                        }
                    </mat-form-field>
                </mat-grid-tile>
                <mat-grid-tile colspan="1"></mat-grid-tile>
            </mat-grid-list>

        </form>
        <div class="dragCards">
            <h2 class="dragCardsHeading">{{ 'GROUPS' | translate }}</h2>

            <div class="drag-contrainer">

                <mat-grid-list cols="3" rowHeight="400px">
                    <mat-grid-tile colspan="1">
                        <div class="example-container">
                            <div #todoList="cdkDropList" (cdkDropListDropped)="drop($event)" [cdkDropListConnectedTo]="[doneList]" [cdkDropListData]="todo"
                                cdkDropList class="example-list-drag">
                                @for (item of todo; track item) {
                                    <div class="example-box-drag" cdkDrag>{{ item }}</div>
                                }
                            </div>
                        </div>

                        <!-- <mat-label>{{ 'Select' | translate }}</mat-label>
                        <mat-select formControlName="users" size="small">
                            @for (item of todo; track item) {
                                <mat-option [value]="item">{{ item }}</mat-option>
                            }
                        </mat-select> -->

                    </mat-grid-tile>
                    <mat-grid-tile colspan="1">
                        <div class="example-container-buttons">
                            <button (click)="moveRight()" class="move-button">{{right}}</button> <!-- Add the move all button here -->
                            <button (click)="moveLeft()" class="move-button">{{left}}</button> <!-- Add the move all button here -->
                        </div>
                    </mat-grid-tile>
                    <mat-grid-tile colspan="1">
                        <div class="example-container">
                            <div #doneList="cdkDropList" (cdkDropListDropped)="drop($event)" [cdkDropListConnectedTo]="[todoList]" [cdkDropListData]="done"
                                cdkDropList class="example-list-drag">
                                @for (item of done; track item) {
                                    <div class="example-box-drag" cdkDrag>{{ item }}</div>
                                }
                            </div>
                        </div>
                    </mat-grid-tile>
                </mat-grid-list>
            </div>

        </div>
    </mat-card-content>

</mat-card>